import type { PlannerConfig } from "../types";
import { EMPTY_READ, type CubeRead } from "./sight";

export interface CubeBelief {
  valid: boolean;
  blind: boolean;
  reads: number;
  poseOk: boolean;
  votes: number;
  color: number;
  pose: CubeRead | null;
  newest: CubeRead;
}

export class Belief {
  private readonly ring: CubeRead[] = [];
  private reads = 0;

  constructor(private readonly cfg: PlannerConfig) {}

  clear(): void {
    this.ring.length = 0;
    this.reads = 0;
  }

  push(read: CubeRead): void {
    this.reads += 1;
    this.ring.push(read);
    while (this.ring.length > Math.max(1, this.cfg.belief_window)) this.ring.shift();
  }

  tally(): CubeBelief {
    const histogram = [0, 0, 0, 0, 0, 0];
    for (const read of this.ring) {
      if (read.colorOk && read.color >= 0 && read.color < 6) {
        histogram[read.color] = (histogram[read.color] ?? 0) + 1;
      }
    }
    const votes = Math.max(...histogram);
    const color = votes > 0 ? histogram.indexOf(votes) : -1;
    const pose = [...this.ring].reverse().find((read) => read.ok && read.color === color) ?? null;
    return {
      valid: votes >= this.cfg.belief_min_votes,
      blind: this.reads < this.cfg.belief_min_votes,
      reads: this.reads,
      poseOk: pose !== null,
      votes,
      color,
      pose,
      newest: this.ring.at(-1) ?? EMPTY_READ,
    };
  }
}
